/* Benzene custom homepage — reveal-on-scroll + story timeline rail.
   Guarded so multiple sections loading this file only initialise once. */
(function () {
  if (window.__bzHome) return;
  window.__bzHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('.bz-home .reveal:not(.in)'));
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initRails() {
    [].slice.call(document.querySelectorAll('.bz-home .rail')).forEach(function (rail) {
      if (rail.__bzBound) return;
      rail.__bzBound = true;
      var fill = rail.querySelector('.rfill');
      if (!fill) return;
      var steps = [].slice.call(rail.querySelectorAll('.step'));
      function update() {
        var rect = rail.getBoundingClientRect(), vh = window.innerHeight;
        var p = (vh * 0.6 - rect.top) / rect.height;
        p = Math.max(0, Math.min(1, p));
        if (reduce) p = 1;
        var H = rail.offsetHeight || 1;
        fill.style.height = (p * H) + 'px';
        // the line's tip = the fill's bottom edge, in rail coordinates
        var tip = fill.offsetTop + (p * H);
        steps.forEach(function (s) {
          var d = s.querySelector('.dot'); if (!d) return;
          // dot centre relative to the RAIL (step offset + dot offset within the step)
          var dy = s.offsetTop + d.offsetTop + d.offsetHeight / 2;
          s.classList.toggle('on', tip >= dy);
        });
      }
      update();
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
  }

  // The theme header is position:fixed and the homepage has no top offset,
  // so push the first section (the bundle) down by the live header height.
  function offsetHeader() {
    var bundle = document.querySelector('.bz-home.bz-bundle');
    if (!bundle) return;
    var h = 0, all = document.body.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) {
      var cs = window.getComputedStyle(all[i]);
      if (cs.position === 'fixed') {
        var r = all[i].getBoundingClientRect();
        if (r.top <= 2 && r.width >= 300 && r.height > 30 && r.height < 400 && r.height > h) h = r.height;
      }
    }
    if (h > 0) bundle.style.paddingTop = (h + 22) + 'px';
  }

  function init() { initReveal(); initRails(); offsetHeader(); }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  var bzrt;
  window.addEventListener('resize', function () { clearTimeout(bzrt); bzrt = setTimeout(offsetHeader, 150); });
  // Re-init inside the Shopify theme editor when sections are added/changed.
  document.addEventListener('shopify:section:load', init);
})();
